import React from "react";
import Login from "../../screens/Login/index";
import { Modal } from "react-bootstrap";
import "./styles.scss";

export default function LoginModal(props) {
  const {
    showLogin,
    closeLoginModal,
    username,
    getLoggedInDetails,
    isMobile,
    showSignUpModal,
    handleFormInputChange,
    showAlert,
    askUsername,
    cancelPlaceOrder,
  } = props;
  return (
    <Modal
      show={showLogin}
      onHide={() => {
        cancelPlaceOrder();
        closeLoginModal();
      }}
      className="login-modal"
      centered={!isMobile}
    >
      <Modal.Header closeButton>
        <Modal.Title>Login</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center">
        <Login
          username={username}
          closeLoginModal={() => closeLoginModal()}
          getLoggedInDetails={getLoggedInDetails}
          isMobile={isMobile}
          showSignUpModal={showSignUpModal}
          handleFormInputChange={handleFormInputChange}
          showAlert={showAlert}
          askUsername={askUsername}
          cancelPlaceOrder={cancelPlaceOrder}
        />
      </Modal.Body>
    </Modal>
  );
}
